





































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import editDialog from './PlywoodProcessingProcessProductivitiesEditDialog.vue';
import Draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import CDeleteDialog from '@/components/base/dialog/CDeleteDialog.vue';

@Component({
    components: {
        CDeleteDialog,
        CSimpleTable,
        editDialog,
        Draggable,
    },
})
export default class PlywoodProcessingProcessProductivities extends Vue {
    @Prop() data!: any;
    private loading: boolean = false;
    private dictionary: any = null;

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    get dictionaryDopItems() {
        return [
            {Id: -1, Description: this.$t('Common.NotSet')},
            {Id: null, Description: this.$t('Common.All')},
        ];
    }

    get tableAddData() {
        return {
            IdPlywoodGrade: null,
            IdPlywoodSize: null,
            IdPlywoodThickness: null,
            IdPlywoodSpecie: null,
            IdPlywoodSurface: null,
            IdPlywoodWaterResistance: null,
            IsForTenonGroove: null,
            MainProductivity: 0,
            ScannerProductivity: 0,
        };
    }

    created() {
        this.getData();
    }

    async getData() {
        this.loading = true;
        try {
            const descriptions = await this.getDescriptions();
            this.dictionary = this.getDictionary(descriptions.map((description: any) => description.data));
        } finally {
            this.loading = false;
        }
    }

    getDescriptions() {
        return Promise.all([
            this.getPlywoodGradeDescriptions(),
            this.getPlywoodSizeDescriptions(),
            this.getPlywoodThicknessDescriptions(),
            this.getPlywoodSpecieDescriptions(),
            this.getPlywoodSurfaceDescriptions(),
            this.getPlywoodWaterResistanceDescriptions(),
            this.getTenonGrooveDescriptions(),
        ]);
    }

    add() {
        (this.$refs.editing as any).open(cloneDeep(this.tableAddData), {
            saveCallback: (payload: any) => {
                const data = this.data.slice();
                data.push(payload);
                this.$emit('update:data', data);
                (this.$refs.editing as any).close();
            },
        });
    }

    deleteAll() {
        (this.$refs.deleting as any).open(null, {
            deleteCallback: () => {
                this.$emit('update:data', []);
                (this.$refs.deleting as any).close();
            },
        });
    }

    edit(item: any, index: number) {
        (this.$refs.editing as any).open(cloneDeep(item), {
            saveCallback: (payload: any) => {
                const data = this.data.slice();
                data[index] = payload;
                this.$emit('update:data', data);
                (this.$refs.editing as any).close();
            },
        });
    }

    itemDelete(item: any) {
        (this.$refs.deleting as any).open(item, {
            deleteCallback: () => {
                this.$emit(
                    'update:data',
                    this.data.filter((el: any) => el !== item),
                );
                (this.$refs.deleting as any).close();
            },
        });
    }

    copy(item: any) {
        (this.$refs.editing as any).open(cloneDeep(item), {
            saveCallback: (payload: any) => {
                const data = this.data.slice();
                data.push(payload);
                this.$emit('update:data', data);
                (this.$refs.editing as any).close();
            },
        });
    }

    getTenonGrooveDescriptions() {
        return this.$http.get(`${this.$api.catalogues.tenonGroove}/GetDescriptions`);
    }
    getPlywoodGradeDescriptions() {
        return this.$http.get(`${this.$api.catalogues.plywoodGrade}/GetDescriptions`);
    }
    getPlywoodSizeDescriptions() {
        return this.$http.get(`${this.$api.catalogues.plywoodSize}/GetDescriptions`);
    }
    getPlywoodThicknessDescriptions() {
        return this.$http.get(`${this.$api.catalogues.plywoodThickness}/GetDescriptions`);
    }
    getPlywoodSpecieDescriptions() {
        return this.$http.get(`${this.$api.catalogues.plywoodSpecie}/GetDescriptions`);
    }
    getPlywoodSurfaceDescriptions() {
        return this.$http.get(`${this.$api.catalogues.plywoodSurface}/GetDescriptions`);
    }
    getPlywoodWaterResistanceDescriptions() {
        return this.$http.get(`${this.$api.catalogues.plywoodWaterResistance}/GetDescriptions`);
    }
    getDictionary(data: any) {
        const dictionary: {[key: string]: any} = {
            plywoodGrade: data[0],
            plywoodSize: data[1],
            plywoodThickness: data[2],
            plywoodSpecie: data[3],
            plywoodSurface: data[4],
            plywoodWaterResistance: data[5],
            tenonGroove: data[6],
        };
        Object.keys(dictionary).forEach((key: string) => {
            const descriptions = dictionary[key];
            const map = new Map();
            descriptions.forEach((item: any) => {
                map.set(item.Id, item.Description);
                this.dictionaryDopItems.forEach((item: any) => map.set(item.Id, item.Description));
            });
            dictionary[key] = map;
        });
        return dictionary;
    }
}
